import { render, staticRenderFns } from "./DeviceConfiguration.vue?vue&type=template&id=64a1ee9f&"
import script from "./DeviceConfiguration.vue?vue&type=script&lang=js&"
export * from "./DeviceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DeviceConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports